'use client'

import React, { ReactNode } from 'react'
import { motion } from 'framer-motion'
import clsx from 'clsx'

type Props = {
  className?: string
  children: ReactNode
}

export default function SlideUp({ className, children }: Props) {
  return (
    <div className={clsx('overflow-hidden', className)}>
      <motion.div
        variants={{
          start: {
            y: 100,
          },
          end: {
            y: 0,
          },
        }}
        transition={{ ease: 'easeOut', duration: 0.3 }}
      >
        {children}
      </motion.div>
    </div>
  )
}
